import SpriteSymbol from "../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vibrate-icon",
  "use": "vibrate-icon-usage",
  "viewBox": "0 0 114 85",
  "content": "<symbol viewBox=\"0 0 114 85\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"vibrate-icon\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M28 4.5C28 2.01472 30.0147 0 32.5 0H81.5C83.9853 0 86 2.01472 86 4.5V80.5C86 82.9853 83.9853 85 81.5 85H32.5C30.0147 85 28 82.9853 28 80.5V4.5ZM37 9V76H77V9H37ZM91 19H100V67H91V19ZM23 19H14V67H23V19ZM105 28H114V58H105V28ZM9 28H0V58H9V28Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol